import { __require as requireSharedStore } from './node_modules-core-js-internals-shared-store.js';

var shared;
var hasRequiredShared;

function requireShared () {
	if (hasRequiredShared) return shared;
	hasRequiredShared = 1;
	var store = requireSharedStore();

	shared = function (key, value) {
	  return store[key] || (store[key] = value || {});
	};
	return shared;
}

export { requireShared as __require };
//# sourceMappingURL=node_modules-core-js-internals-shared.js.map
